import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import CSSModules from 'react-css-modules'
import styles from './timer.css'

let localMinutes = 1
let localSeconds = 5
let refreshTimer

const getSecondDigit = digits => {
  return ('' + digits)[1] ? digits : '0' + digits
}

class Timer extends Component {
  state ={
    timer:false
  }
  render() {
    const { timer, startTimer } = this.props
    const { minutes, seconds } = timer
    return (
      <div>
        <div className={styles.timer}>
          <div className={styles.timerWrap}>
            <div className={styles.timerDisplay}>
              <span ref="timerMin"  className={styles.timerMin}>{getSecondDigit(minutes)}</span>
              <span className={styles.timerDots}>:</span>
              <span ref="timerSec"  className={styles.timerSec}>{getSecondDigit(seconds)}</span>
            </div>

            <button className={!this.state.timer ? styles.btnBaseTimer : styles.btnBaseTimerActive} onClick={e => {
            e.preventDefault()
                this.setState({
                    timer:!this.state.timer
                })
            localMinutes = 1
            localSeconds = 5
            clearInterval(refreshTimer)
                if(!this.state.timer){
                    refreshTimer = setInterval(() => {
                        if (localMinutes > 0 || localSeconds > 0) {
                            if (localSeconds === 0 && localMinutes > 0) {
                                localMinutes -= 1
                                localSeconds = 59
                            } else {
                                localSeconds -= 1
                            }

                            startTimer({ minutes: localMinutes, seconds: localSeconds })
                        }
                    }, 1000)
                }

          }}>
                Начать
              </button>



          </div>
        </div>

      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  startTimer: bindActionCreators(({minutes, seconds}) => ({
    type: 'START_TIMER',
    timer: { minutes, seconds }
  }), dispatch)
})

const mapStateToProps = state => {
  return { timer: state.timer }
}

Timer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Timer)

export default CSSModules(Timer, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/componentKit/Timer.js